import {Injectable} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';

import {mapFields, TOOL, ToolTypes} from 'src/app/constants/map';
import {MapboxglSearchComponent} from './mapboxgl-search.component';
import {CommonService} from '../../../services/common.service';
import {FormGroup} from '@angular/forms';

@Injectable({
    providedIn: 'root'
})
export class MapboxglSearchControl {

    public service: any;
    private container: any;
    public button: HTMLButtonElement = null as any;
    public dialogRef: MatDialogRef<any> = null as any;
    private logOpen: boolean;
    private icon: any;
    private isActive: boolean;
    private commonService: CommonService;
    private createForm: FormGroup;
    private item: any;

    constructor(
        {mapboxglService}
    ) {
        this.service = mapboxglService;
        this.eventClick = this.eventClick.bind(this);
        this.service.controlOnLoadedSubject.subscribe(control => {
            if (control !== ToolTypes.search_item) {
                if (this.dialogRef) {
                    this.dialogRef.close();
                }
                if (this.button) {
                    this.button.classList.remove('active');
                }
            }
        });
    }

    openDialog(): void {
        const dialogWidth = 300;
        if (this.button.classList.contains('active')) {
            this.button.classList.remove('active');
            this.logOpen = true;
        }
        // tslint:disable-next-line:no-non-null-assertion
        const offsetLeft = document.querySelector<HTMLElement>('.mapbox-gl-search')!.getBoundingClientRect().left;
        this.dialogRef = this.service.dialog.open(MapboxglSearchComponent, {
            data: this,
            height: 'auto',
            width: `${dialogWidth}px`,
            hasBackdrop: false,
            panelClass: 'mapboxLayer'
        });
        this.dialogRef.updatePosition({
            top: `${10}px`,
            left: `${offsetLeft - dialogWidth - 5}px`
        });
        this.dialogRef.afterClosed().subscribe(res => {
            this.logOpen = false;
            this.button.classList.remove('active');
            this.icon.style.color = 'black';
        });
    }

    eventClick(e: any): void {
        this.button = e.currentTarget;
        this.icon = this.button.querySelector<HTMLElement>('.material-icons-outlined');
        if (!this.logOpen) {
            this.button.classList.add('active');
            this.icon.style.color = 'red';
            this.service.controlOnLoadedSubject.next(ToolTypes.search_item);
            this.openDialog();
            this.isActive = true;
        } else if (this.logOpen) {
            this.button.classList.remove('active');
            this.icon.style.color = 'black';
            this.service.layers.map(layer => {
                layer.display = false;
                this.service.toggleShowLayer(layer.id);
            });
            this.dialogRef.close();
            this.logOpen = false;
            this.isActive = false;
        }
    }

    onAdd(): any {
        const changeStyleToolInfo: TOOL = {
            name: 'Search',
            // iconClass: 'esri-icon esri-icon-search',
            iconClass: 'material-icons-outlined',
            code: 'SEARCH_TOOL',
            active: false,
            className: 'search'
        };
        const changeStyleTool = this.service.utilityFn.createTool(changeStyleToolInfo, this.eventClick);
        this.container = this.service.utilityFn.createControl([changeStyleTool], 'mapbox-gl-search');
        return this.container;
    }

    onRemove(): void {
        this.container.parentNode.removeChild(this.container);
    }

}
